import { api_configuration } from "../../common";
import api_cs = api_configuration.types.client_state.alan_api;

export const Saving = Symbol("SavingProperty");
export const ModifiedDuringSave = Symbol("ModifiedDuringSave");
export type Saving = typeof Saving;
export type ModifiedDuringSave = typeof ModifiedDuringSave;
type ModifiedSaveStatus = Saving | ModifiedDuringSave | undefined;

export function setToSaving(
	property:
		| api_cs.Cyes__modified__yes__is_editable__text
		| api_cs.Cyes__modified__yes__is_editable__number
		| api_cs.Cyes__modified__yes__is_editable__file
		| api_cs.Cyes__is_modified
) {
	toSavestatus(property).__alan__saving = Saving;
}

export function setModified(
	property:
		| api_cs.Cyes__modified__yes__is_editable__text
		| api_cs.Cyes__modified__yes__is_editable__number
		| api_cs.Cyes__modified__yes__is_editable__file
		| api_cs.Cyes__is_modified
) {
	const saving_object = toSavestatus(property);
	if (saving_object.__alan__saving === Saving) {
		saving_object.__alan__saving = ModifiedDuringSave;
	}
}

export function shouldResetModifiedState(
	property:
		| api_cs.Cyes__modified__yes__is_editable__text
		| api_cs.Cyes__modified__yes__is_editable__number
		| api_cs.Cyes__modified__yes__is_editable__file
		| api_cs.Cyes__is_modified
) {
	const saving_object = toSavestatus(property);
	return saving_object.__alan__saving === Saving;
}

function toSavestatus(object: any): { __alan__saving: ModifiedSaveStatus } {
	return object;
}
